import { EveryCigSprite, EveryCigSpriteConfig, EveryCigSpriteType } from "../EveryCigTypes"
import { EveryCigBodyPartButtonContainer } from "./EveryCigBodyPartButtonContainer"
import { EveryCigDropdownScreenContainer } from "./EveryCigDropdownScreenContainer"
import { EveryCigWarningScreen } from "./EveryCigWarningScreen"

export class EveryCigSpriteCreator {

    constructor(private game: Phaser.Game) {}

    create = (type: EveryCigSpriteType, config: EveryCigSpriteConfig): EveryCigSprite => {
        const {x, y, button} = config
        const group = config.group ? config.group : this.game.add.group()
        let sprite: EveryCigSprite
        switch (type) {
            case EveryCigSpriteType.WARNING_SCREEN:
                sprite = new EveryCigWarningScreen(this.game, group, x, y)
                break
            case EveryCigSpriteType.BODY_PART_BUTTONS:
                sprite = new EveryCigBodyPartButtonContainer(this.game, button, group)
                break
            case EveryCigSpriteType.VOTE_SCREEN:
                sprite = new EveryCigDropdownScreenContainer(this.game, group, x, y)
                break
            default:
                throw new Error("Unimplemented sprite type.")
        }

        return sprite
    }
}
